import { useRef, useState } from 'react';
import { useRect } from 'react-use-rect';

interface Out {
  top: boolean;
  left: boolean;
  bottom: boolean;
  right: boolean;
}

export function useIsOutOfViewport() {
  const [out, setOut] = useState<Out>({
    top: false,
    left: false,
    bottom: false,
    right: false
  });
  const [containerHeight, setContainerHeight] = useState(0);
  const ref = useRef<HTMLDivElement>(null);

  const [containerRect, revalidate] = useRect(
    ({ top, left, bottom, right, height: containerHeight }) => {
      const viewportHeight =
        window.innerHeight || document.documentElement.clientHeight;
      const viewportWidth =
        window.innerWidth || document.documentElement.clientWidth;

      const { clientWidth = 0, clientHeight = 0 } = ref.current ?? {};

      setOut({
        top: top - clientHeight < 0,
        left: left + clientWidth > viewportWidth,
        bottom: bottom + clientHeight > viewportHeight,
        right: right - clientWidth < 0
      });
      setContainerHeight(containerHeight);
    },
    { resize: true }
  );

  return { out, ref, containerHeight, containerRect, revalidate };
}
